var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.0268C31 21.0893 17.5629 28.4247 16.9907 28.7277C16.8398 28.8088 16.6713 28.8513 16.5 28.8513C16.3287 28.8513 16.1602 28.8088 16.0093 28.7277C15.4371 28.4247 2 21.0893 2 12.0268C2.0024 9.89869 2.84885 7.85844 4.35364 6.35364C5.85844 4.84885 7.89869 4.0024 10.0268 4C12.7002 4 15.0409 5.14964 16.5 7.0929C17.9591 5.14964 20.2998 4 22.9732 4C25.1013 4.0024 27.1416 4.84885 28.6464 6.35364C30.1512 7.85844 30.9976 9.89869 31 12.0268Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRedIcon);
export default __webpack_public_path__ + "static/media/heart-red-icon.d3e3681762a36ed8fd59e44fb41437ff.svg";
export { ForwardRef as ReactComponent };